import Vue from 'vue';

// 定義 Loading 組件
const LoadingComponent = Vue.extend({
  name: 'Loading',
  props: {
    text: {
      type: String,
      default: '加載中...'
    },
    spinner: {
      type: String,
      default: 'default'
    },
    background: {
      type: String,
      default: 'rgba(255, 255, 255, 0.9)'
    },
    fullscreen: {
      type: Boolean,
      default: false
    }
  },
  render(h) {
    if (this.fullscreen) {
      return h('div', {
        class: ['fullscreen-loading'],
        style: {
          background: this.background
        }
      }, [
        this.renderSpinner(h),
        h('p', { class: 'loading-text' }, this.text)
      ]);
    }
    
    return h('div', {
      class: ['loading-mask'],
      style: {
        background: this.background
      }
    }, [
      this.renderSpinner(h),
      h('p', { class: 'loading-text' }, this.text)
    ]);
  },
  methods: {
    renderSpinner(h) {
      // 默認加載圖標 - 點陣動畫
      return h('div', { class: 'loading-spinner' }, 
        Array.from({ length: 9 }, (_, i) => 
          h('div', { class: 'loading-spinner-dot' })
        )
      );
    }
  }
});

// 創建 Loading 構造函數
const LoadingConstructor = Vue.extend(LoadingComponent);

// 定義指令
const loadingDirective = {
  bind(el, binding) {
    const text = el.getAttribute('loading-text') || '加載中...';
    const spinner = el.getAttribute('loading-spinner') || 'default';
    const background = el.getAttribute('loading-background') || 'rgba(255, 255, 255, 0.9)';
    
    const instance = new LoadingConstructor({
      propsData: {
        text,
        spinner,
        background,
        fullscreen: false
      }
    }).$mount();
    
    el.instance = instance;
    el.loadingPosition = el.style.position;
    
    if (binding.value) {
      appendLoading(el, instance);
    }
  },
  update(el, binding) {
    const instance = el.instance;
    if (binding.oldValue !== binding.value) {
      if (binding.value) {
        appendLoading(el, instance);
      } else {
        removeLoading(el, instance);
      }
    }
  },
  unbind(el) {
    const instance = el.instance;
    if (instance.$el.parentNode === el) {
      el.removeChild(instance.$el);
    }
    instance.$destroy();
  }
};

function appendLoading(el, instance) {
  if (el.style.position !== 'absolute' && el.style.position !== 'fixed' && el.style.position !== 'relative') {
    el.style.position = 'relative';
  }
  el.appendChild(instance.$el);
  Vue.nextTick(() => {
    instance.visible = true;
  });
}

function removeLoading(el, instance) {
  instance.visible = false;
  setTimeout(() => {
    if (instance.$el.parentNode === el) {
      el.removeChild(instance.$el);
    }
    if (el.loadingPosition) {
      el.style.position = el.loadingPosition;
    } else {
      el.style.position = '';
    }
  }, 300);
}

// 創建插件
const LoadingPlugin = {
  install(Vue) {
    // 註冊指令
    Vue.directive('loading', loadingDirective);
    
    // 添加服務方法
    Vue.prototype.$loading = function(options) {
      options = options || {};
      
      const instance = new LoadingConstructor({
        propsData: {
          text: options.text || '加載中...',
          spinner: options.spinner || 'default',
          background: options.background || 'rgba(255, 255, 255, 0.9)',
          fullscreen: options.fullscreen !== false
        }
      }).$mount();
      
      if (options.target) {
        options.target.appendChild(instance.$el);
      } else {
        document.body.appendChild(instance.$el);
      }
      
      Vue.nextTick(() => {
        instance.visible = true;
      });
      
      return {
        close: () => {
          instance.visible = false;
          setTimeout(() => {
            if (instance.$el.parentNode) {
              instance.$el.parentNode.removeChild(instance.$el);
            }
            instance.$destroy();
          }, 300);
        }
      };
    };
  }
};

export default LoadingPlugin;